import QuestionRecommendationApi from '@/api/question-recommendations'

const state = {
  questionRecommendations: [],
}

const actions = {
  async fetchQuestionRecommendations({ rootState }) {
    const response = await QuestionRecommendationApi
      .generateQuestionRecommendation({ slideId: rootState.slideActive.id })
    return response.questions || []
  },
}

export default {
  namespaced: true,
  state,
  actions,
}
